/*
copyChatMessages.js
拷贝最后一对消息至剪贴板
 */
import { message } from "antd";

const copyChatMessages = (messages) => {
    try {
        // 1. 校验消息数组
        if (!messages || messages.length === 0) {
            message.warning('没有可复制的内容');
            return;
        }

        // 2. 获取最后一条消息作为回答 (LLM 的回答通常是数组中的最后一项)
        // 注意：如果你的数据结构中最后一条可能是用户提问，请根据实际业务逻辑调整索引
        const lastMessage = messages[messages.length - 1];

        // 确保存在 message 字段且不为空
        if (!lastMessage || !lastMessage.message) {
            message.warning('回答内容为空');
            return;
        }

        const responseText = lastMessage.message;

        // 3. 执行复制操作
        // 判断浏览器是否支持 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
            // 现代浏览器 (HTTPS 环境)
            navigator.clipboard.writeText(responseText).then(() => {
                message.success('回答已复制到剪贴板');
            }).catch(err => {
                console.error('Clipboard API Error:', err);
                // 如果 Clipboard API 失败，降级到传统方式
                fallbackCopyTextToClipboard(responseText);
            });
        } else {
            // 对于不支持 Clipboard API 或非 HTTPS 环境，使用传统方式
            fallbackCopyTextToClipboard(responseText);
        }
    } catch (error) {
        console.log(error);
        message.error('复制失败,请稍后再试').then();
    }
};

/**
 * 传统的复制方法（降级方案）
 * @param {string} text 
 */
const fallbackCopyTextToClipboard = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    // 保持样式隐藏，避免页面闪烁
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.width = '2em';
    textarea.style.height = '2em';
    textarea.style.padding = '0';
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.background = 'transparent';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            message.success('回答已复制到剪贴板');
        } else {
            message.error('复制失败，请手动复制');
        }
    } catch (err) {
        console.error('Fallback Copy Error:', err);
        message.error('复制失败，请手动复制');
    }

    document.body.removeChild(textarea);
};

export default copyChatMessages;
